import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-jian",
  "use": "icon-jian-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 16\" id=\"icon-jian\">\r\n<title>减</title>\r\n<desc>Created with Sketch.</desc>\r\n<g id=\"icon-jian_矩形_1_\">\r\n\t<path d=\"M5,7.5h6c0.276,0,0.5,0.224,0.5,0.5l0,0c0,0.276-0.224,0.5-0.5,0.5H5C4.724,8.5,4.5,8.276,4.5,8l0,0\r\n\t\tC4.5,7.724,4.724,7.5,5,7.5z\" />\r\n\t<path d=\"M11,9H5C4.449,9,4,8.552,4,8c0-0.551,0.449-1,1-1h6c0.552,0,1,0.449,1,1C12,8.552,11.552,9,11,9z M11,8v0.5V8L11,8z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/jian.svg
// module id = 5KJ5
// module chunks = 31